import { DialogActions, Typography } from '@mui/material';
import { getCompanyConfigOld } from 'lib/api/company';
import CreditRequestStatus from 'pages/Finance/Components/Financing/CreditsRequests/components/common/CreditRequestStatus';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateCreditRequestQuote } from '../../../../../../../../../../../../../lib/api/creditRequest';
// Temporary: Using factoring API until credit request API is available
import { getExecutivesAvailableForFactoring } from '../../../../../../../../../../../../../lib/api/factoring';
import CustomAlert from '../../../../../../../../../../../../../lib/designSystem/Alert';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../../../lib/designSystem/CircularProgress';
import { validateCreditRequestForm } from '../../../../../create';
import CreditSimulator from '../../../../../create/components/Simulator';

const ShoppingCartInReview = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    setUp,
    setSuccessOpen,
    setFailureOpen,
    handleOpenDeleteConfirmModal,
    setLoading,
    handleOpenUpdateStatusModal,
    canEditRequest,
  } = props;
  const [localLoading, setLocalLoading] = useState(false);
  const [creditDetails, setCreditDetails] = useState<any>(openRequest);
  const [openWarning, setOpenWarning] = useState(false);
  const [editing, setEditing] = useState(false);
  const [amortizationSchedule, setAmortizationSchedule] = useState<any>(
    openRequest.documents,
  );

  const [canRateBeZero, setCanRateBeZero] = useState<boolean | undefined>(
    undefined,
  );
  const [canArrearRateBeZero, setCanArrearRateBeZero] = useState<
    boolean | undefined
  >(undefined);
  const [selectedDocuments, setSelectedDocuments] = useState<string[]>([]);
  const [executivesPortfolio, setExecutivesPortfolio] = useState([]);
  const [executivesAll, setExecutivesAll] = useState([]);
  const dispatch = useDispatch();

  const setDocumentsToApply = (docs: any[]) => {
    setCreditDetails((prev: any) => ({
      ...prev,
      documentsToApply: docs,
    }));
  };

  const handleEdit = () => {
    setOpenWarning(true);
    setEditing(true);
  };

  const fetchExecutives = async () => {
    if (openRequest?.businessIdentifier) {
      try {
        const response = await getExecutivesAvailableForFactoring(
          dispatch,
          openRequest.businessIdentifier,
        );
        setExecutivesPortfolio(response.usersWithBusinessInPortfolio);
        setExecutivesAll(response.allUsers);
      } catch (error) {
        console.error('Error fetching executives:', error);
      }
    }
  };

  const fetchConfigurationValues = async () => {
    const configurations = await getCompanyConfigOld(
      dispatch,
      ['credit_request_rate_zero', 'credit_request_arrear_rate_zero'].join(','),
    );
    setCanRateBeZero(configurations.credit_request_rate_zero === '1');
    setCanArrearRateBeZero(
      configurations.credit_request_arrear_rate_zero === '1',
    );
  };

  const handleSubmit = async () => {
    if (
      !validateCreditRequestForm(
        creditDetails,
        canRateBeZero,
        canArrearRateBeZero,
      )
    ) {
      return;
    }
    setLocalLoading(true);
    if (setLoading) setLoading(true);
    try {
      await updateCreditRequestQuote(dispatch, creditDetails.id, {
        amount: Number(creditDetails.amount),
        type: creditDetails.type,
        interestType: creditDetails.interestType,
        operationCost: Number(creditDetails.operationCost),
        otherExpenses: Number(creditDetails.otherExpenses),
        operationDate: new Date(creditDetails.operationDate),
        taxes: Number(creditDetails.taxes),
        notary: Number(creditDetails.notary),
        rate: Number(creditDetails.rate),
        arrearRate: Number(creditDetails.arrearRate),
        cuotas: amortizationSchedule,
        paymentDate:
          amortizationSchedule[amortizationSchedule.length - 1].paymentDate,
        warranties: creditDetails.warranties,
        guaranteeAmount: Number(creditDetails.guaranteeAmount),
        guaranteeObservation: creditDetails.guaranteeObservation,
        periodicity: creditDetails.periodicity,
        amountToApply: Number(creditDetails.amountToApply),
        documentsToApply: creditDetails.documentsToApply.map((doc: any) => {
          return {
            id: doc.id,
            amountToConciliate: doc.amountToConciliate,
          };
        }),
        operationIVA: Math.round(creditDetails.operationCost * 0.19),
        ownerId: creditDetails.ownerId || creditDetails.executive,
      });
      setSuccessOpen('Crédito editado correctamente');
      await setUp();
      setLocalLoading(false);
      if (setLoading) setLoading(false);
      setOpenShoppingCart(false);
    } catch (error) {
      setLocalLoading(false);
      if (setLoading) setLoading(false);
      setFailureOpen('Error al editar el crédito');
      console.error(error);
    }
  };

  useEffect(() => {
    void fetchConfigurationValues();
    void fetchExecutives();
  }, []);

  // Ensure executives are loaded when component mounts
  useEffect(() => {
    if (
      openRequest?.businessIdentifier &&
      executivesPortfolio.length === 0 &&
      executivesAll.length === 0
    ) {
      void fetchExecutives();
    }
  }, [openRequest, executivesPortfolio.length, executivesAll.length]);

  useEffect(() => {
    if (openRequest?.documentsToApply) {
      setCreditDetails((prev: any) => ({
        ...prev,
        documentsToApply: openRequest.documentsToApply,
      }));
      setSelectedDocuments(
        openRequest.documentsToApply.map((doc: any) => doc.documentId) || [],
      );
    }
  }, [openRequest]);

  if (localLoading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <CreditRequestStatus openRequest={openRequest} audienceType="received" />
      <CreditSimulator
        creditDetails={creditDetails}
        setCreditDetails={setCreditDetails}
        amortizationSchedule={amortizationSchedule}
        setAmortizationSchedule={setAmortizationSchedule}
        editing={editing}
        documents={openRequest.documents}
        selectedRequest={openRequest}
        setDocumentsToApply={setDocumentsToApply}
        documentsToApply={creditDetails.documentsToApply}
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        executivesPortfolio={executivesPortfolio}
        executivesAll={executivesAll}
      />
      {!editing && (
        <div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 0px',
              gap: '10px',
            }}
          >
            <div
              style={{
                marginTop: 10,
                paddingBottom: 10,
                display: 'flex',
                gap: 10,
              }}
            >
              <Typography
                color="error"
                variant="body1"
                fontWeight="bold"
                style={{ cursor: 'pointer' }}
                onClick={() => handleOpenDeleteConfirmModal()}
              >
                Eliminar
              </Typography>
              {canEditRequest() && (
                <Typography
                  color="orange"
                  variant="body1"
                  fontWeight="bold"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleOpenUpdateStatusModal()}
                >
                  Editar Estado
                </Typography>
              )}
            </div>
            <div
              style={{
                marginTop: 10,
                paddingBottom: 10,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
              }}
            >
              <CustomButton
                color="secondary"
                onClick={() => {
                  setOpenShoppingCart(false);
                }}
              >
                Salir
              </CustomButton>
              <CustomButton color="warning" onClick={() => handleEdit()}>
                Editar
              </CustomButton>
            </div>
          </div>
        </div>
      )}
      {editing && !localLoading && (
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setEditing(false)}>
            Cancelar
          </CustomButton>
          <CustomButton color="success" onClick={() => handleSubmit()}>
            Guardar
          </CustomButton>
        </DialogActions>
      )}
      <CustomAlert
        open={openWarning}
        setOpen={setOpenWarning}
        severity="warning"
        title="Atención"
        text="Si guardas los cambios, se borrarán todas las aprobaciones ya realizadas."
        handleClose={() => setOpenWarning(false)}
      />
    </div>
  );
};

export default ShoppingCartInReview;
